import Backbone from 'backbone';

export default class mediaInsight extends Backbone.Model {};
